import { StrictMode } from 'react'
import { prepareLanguage, languageFromBrowserPath } from './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initializeAnalytics } from './utils/analyticsConsent'

initializeAnalytics();

// ─── Global chunk-load error handler ─────────────────────────────────────────
// When Vite splits the bundle into chunks and a deploy happens, old chunk hashes
// become invalid. The browser then gets a "Failed to fetch dynamically imported
// module" error. We catch it here and do a single hard reload so the user gets
// the latest assets automatically.
const RELOAD_KEY = '__chunk_reload__';

window.addEventListener('error', (event) => {
  const msg = event?.message ?? '';
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module')
  ) {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, '1');
      window.location.reload();
    }
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = String(event?.reason ?? '');
  if (
    reason.includes('Failed to fetch dynamically imported module') ||
    reason.includes('Importing a module script failed') ||
    reason.includes('error loading dynamically imported module')
  ) {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, '1');
      window.location.reload();
    }
  }
});
// ─────────────────────────────────────────────────────────────────────────────

const renderApplication = () => createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

void prepareLanguage(languageFromBrowserPath()).then(renderApplication, renderApplication);
